import { strtoupper } from '../../php-compat';
import type { PortEnv } from '../../port-contract';
import { isArray, slot } from './access';
export interface StatusIdScalarDeps { check_uuid(raw: unknown): boolean; }
/** PHP: skill_roll_status_id_scalar (includes/functions/janus/dice/skill_roll_status_trigger_gates.php:336) */
export function skillRollStatusIdScalar(raw: unknown, env: PortEnv<StatusIdScalarDeps>): string {
    if (isArray(raw)) raw = slot(raw, 0);
    return typeof raw === 'string' && raw !== '' && env.deps.check_uuid(raw) ? strtoupper(raw) : '';
}
